import { render, staticRenderFns } from "./TrTextAreaV2.vue?vue&type=template&id=739d22f3&lang=true&"
import script from "./TrTextAreaV2.vue?vue&type=script&lang=js&"
export * from "./TrTextAreaV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTextAreaV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports